import Colors from '../../../../shared/assets/style/default/color';
import Fonts from '../../../../shared/assets/style/default/fonts';
import Screen from '../../../../shared/utils/screen';
import styled from 'styled-components';

const AdsPromoText = styled.div<React.CSSProperties>`
  color: ${Colors['light']};
  font-family: ${Fonts['regular']};
  font-size: ${36 * Screen.widthRatio}px;
  left: ${54 * Screen.widthRatio}px;
  position: absolute;
  top: ${40 * Screen.widthRatio}px;
`;

export default AdsPromoText;
